import { cn } from 'lib/utils';
import { FC } from 'react';
import { BCNX, USDT } from './CurrencyIcons';
import { uiSimpleBox } from '../CutCorners';

interface BPCurrencyIconProps {
  currencyLogo: keyof typeof currencies;
  color?: boolean;
  container?: 'none' | 'circle' | 'box';
  className?: string;
}

export type CurrencyIcon = {
  color: JSX.Element;
  solid: JSX.Element;
};

type CurrencyIcons = Record<string, CurrencyIcon>;

export const currencies: CurrencyIcons = {
  bcnx: {
    color: <BCNX color />,
    solid: <BCNX />,
  },
  usdt: {
    color: <USDT color />,
    solid: <USDT />,
  },
};

const BPCurrencyIcon: FC<BPCurrencyIconProps> = ({
  currencyLogo,
  color = false,
  container = 'none',
  className = '',
}) => {
  const icon = (
    <CurrencyIcon
      currencyLogo={currencyLogo}
      color={color}
      className={container === 'none' ? className : ''}
    />
  );

  return (
    <>
      {container === 'none' && icon}
      {container === 'circle' && (
        <div
          className={cn(
            'inline-grid relative w-[32px] h-[32px] place-content-center rounded-full bg-white/5 border border-white/20',
            className
          )}
        >
          {currencyLogo === 'eth' ? 'A' : icon}
        </div>
      )}
      {container === 'box' && (
        <div
          className={cn(
            'inline-grid relative w-[48px] h-[48px] place-content-center rounded-[8px] bg-white/5',
            className
          )}
        >
          <div
            className={cn(
              'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/30 to-white/10',
              uiSimpleBox.border
            )}
          />
          {icon}
        </div>
      )}
    </>
  );
};

const CurrencyIcon: FC<BPCurrencyIconProps> = ({
  // currencyLogo,
  color = false,
  className = '',
}) => (
  <div
    className={cn(
      'inline-block relative',
      className,
      color ? '' : 'fill-white'
    )}
  >
    <BCNX color={color} />
    {/* {currencyLogo ? currencies[currencyLogo][color ? 'color' : 'solid'] : ''} */}
  </div>
);

export default BPCurrencyIcon;
